module.exports = __webpack_public_path__ + "static/media/m5.270349c6.png";